<template>
  <div>
    <my-header></my-header>

    <div class="content-container-level-1">
      <div class="h-panel">
        <b-button v-b-modal.help-modal>Help</b-button>

        <b-button
          v-if="mayManageWinStreaks"
          :to="{name: 'new_win_streak'}"
          variant="primary"
        >
          New win streak event
        </b-button>
      </div>

      <h2>Win streak events</h2>

      <p v-if="message !== null">
        {{message}}
      </p>

      <table v-if="winStreaks !== null && winStreaks.length > 0" class="table table-bordered text-nowrap">
        <thead class="thead-dark">
          <tr>
            <th scope="col" rowspan="2">Name</th>
            <th scope="col" rowspan="2">Type</th>
            <th scope="col" rowspan="2">Status</th>
            <th scope="col" rowspan="2">Audience</th>
            <th scope="col" colspan="2" class="text-center">Start</th>
            <th scope="col" rowspan="2">Remaining time</th>
            <th scope="col" colspan="2" class="text-center">Finish</th>
            <th scope="col" rowspan="2" v-if="mayManageWinStreaks">Actions</th>
          </tr>
          <tr>
            <th scope="col">planned</th>
            <th scope="col">real</th>
            <th scope="col">planned</th>
            <th scope="col">real</th>
          </tr>
        </thead>
        <tr
          v-for="winStreak in winStreaks"
          :key="winStreak.id"
        >
          <td>
            <win-streak-link :winStreakId="winStreak.id" />
          </td>
          <td class="win-streak-type-name">
            {{getWinStreakTypeName(winStreak.win_streak_id)}}
          </td>
          <td
            :class="getWinStreakStatusClass(winStreak.status)"
          >
            {{winStreak.status | getWinStreakStatusName}}
          </td>
          <td>
            {{winStreak.audience_id | getAudienceName}}
          </td>
          <td>
            {{winStreak.stime | getMomentStr}}
          </td>
          <td>
            {{winStreak.srtime | getWinStreakRealStartTimeStr}}
          </td>
          <td>
            {{getRemainingTimeStr(winStreak)}}
          </td>
          <td>
            {{winStreak.ftime | getMomentStr}}
          </td>
          <td>
            {{winStreak.frtime | getWinStreakRealFinishTimeStr}}
          </td>
          <td
            v-if="mayManageWinStreaks"
          >
            <!--
            <b-button
              v-if="mustShowStartForAllButton(season)"
              @click="runSeasonForAllWithConfirmation(season)"
              variant="success"
              size="sm"
            >
              Start for all
            </b-button>
            <b-button
              v-if="mustShowFinishButton(season)"
              @click="finalizeSeasonWithConfirmation(season)"
              variant="warning"
              size="sm"
              class="ml-2"
            >
              Finish
            </b-button>
            -->
            <b-button
              v-if="mayManageWinStreaks"
              @click="deleteWinStreakWithConfirmation(winStreak)"
              variant="danger"
              size="sm"
              class="ml-2"
            >
              Delete
            </b-button>
          </td>
        </tr>
      </table>

      <loading-indicator
        v-if="isLoading"
      />

    </div>

    <b-modal id="help-modal" title="Help" ok-only ok-title="Close">
      <div class="help">
        <p>
          All win streak events are shown on this page.
        </p>
      </div>
    </b-modal>

  </div>
</template>

<script>
import auth from '../auth';
import { HTTP } from '../http-common';
import notifier from '../notifier';

import { mayManageWinStreaks as doMayManageWinStreaks } from '../model/win-streak.js';
import { getWinStreakStatusClass                      } from '../model/win-streak.js';
import { convertWinStreakTypeArrayToTypeNameMap       } from '../model/win-streak.js';
import { getWinStreakTypeNameFromMap                  } from '../model/win-streak.js';
import { getWinStreakStatusName                       } from '../model/win-streak.js';
import { getWinStreakRealStartTimeStr                 } from '../model/win-streak.js';
import { getWinStreakRealFinishTimeStr                } from '../model/win-streak.js';
import { getWinStreakRemainingTimeStr                 } from '../model/win-streak.js';
import { getAudienceName                              } from '../util.js';

import NowSecMixin from '../NowSecMixin.js';

import MyHeader from './Header.vue';
import LoadingIndicator from './LoadingIndicator.vue';
import WinStreakLink from './WinStreakLink.vue';

import { arrayDeleteFirstItemByValue } from '../util';
import { confirmAction } from '../service/confirm';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'WinStreaks',

  components: {
    MyHeader,
    LoadingIndicator,
    WinStreakLink,
  },

  mixins: [
    NowSecMixin,
  ],

  data() {
    return {
      actor: auth.getViewer(),

      loadState: LOAD_STATE_INIT,
      winStreakTypeNameMap: null,
      winStreaks: null,
    };
  },

  computed: {  
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },

    message() {
      if(this.isLoadedNormal && this.winStreaks !== null && this.winStreaks.length === 0) {
        return 'No win streak events.';
      }
      return null;
    },

    mayManageWinStreaks() {
      return doMayManageWinStreaks(this.actor.role);
    },
  },

  created() {
    this.loadWinStreaks();
  },

  methods: {
    loadWinStreaks() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const url = '/win_streaks';
      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          this.loadState = LOAD_STATE_LOADED_ERROR;
          return;
        }

        this.winStreakTypeNameMap = convertWinStreakTypeArrayToTypeNameMap(data.winStreakTypes);

        const winStreaks = data.winStreaks;
        winStreaks.sort((a, b) => b.stime - a.stime);

        this.winStreaks = winStreaks;

        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(err => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(err, {sender: this});
      });
    },

    getWinStreakStatusClass,

    getRemainingTimeStr(winStreak) {
      return getWinStreakRemainingTimeStr(winStreak, this.nowSec);
    },

    getWinStreakTypeName(winStreakProtoId) {
      return getWinStreakTypeNameFromMap(this.winStreakTypeNameMap, winStreakProtoId);
    },

    deleteWinStreakWithConfirmation(winStreak) {
      notifier.deleteSenderNotifications(this);

      this.confirmWinStreakDeletion(() => {
        this.deleteWinStreak(winStreak);
      });
    },

    // function onConfirmed()
    confirmWinStreakDeletion(onConfirmed) {
      confirmAction(
        this,
        'Are you sure you want to delete this win streak event {env}?',
        'Delete',
        onConfirmed,
      );
    },

    deleteWinStreak(winStreak) {
      notifier.deleteSenderNotifications(this);
      
      const url = `/win_streak/${winStreak.id}/del`;
      HTTP.post(url)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        arrayDeleteFirstItemByValue(this.winStreaks, winStreak);
        notifier.showSuccess('Win streak event deleted.');
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },

  filters: {
    getAudienceName,
    getWinStreakStatusName,
    getWinStreakRealStartTimeStr,
    getWinStreakRealFinishTimeStr,
  },
};
</script>

<style scoped>
  .win-streak-type-name {
    font-weight: bold;
  }
</style>